import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useSearchParams, Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { CheckCircle, XCircle } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function UnsubscribePage() {
  const [searchParams] = useSearchParams();
  const [state, setState] = useState("working");
  const [message, setMessage] = useState("");
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    const email = searchParams.get("email");
    const token = searchParams.get("token");
    if (!email || !token) {
      setState("error");
      setMessage("This unsubscribe link is incomplete. Please use the link from your email.");
      return;
    }
    axios.post(`${API}/newsletter/unsubscribe`, { email, token })
      .then((res) => { setState("done"); setMessage(res.data.message); })
      .catch((err) => {
        setState("error");
        setMessage(err.response?.status === 403 ? "This unsubscribe link is invalid or expired." : "Something went wrong — please try again.");
      });
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-[#FFF1E5]" data-testid="unsubscribe-page">
      <Header />
      <main className="max-w-[600px] mx-auto px-4 py-20 text-center">
        {state === "working" && (
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0F766E] mx-auto"></div>
        )}
        {state === "done" && (
          <div data-testid="unsubscribe-success">
            <CheckCircle size={48} className="text-[#0F766E] mx-auto mb-4" weight="fill" />
            <h1 className="font-serif text-3xl text-[#33302E] mb-3">{message}</h1>
            <p className="text-[#6B6661] mb-8">Sorry to see you go. You can rejoin the Friday Digest anytime.</p>
            <Link to="/" data-testid="unsubscribe-home-link" className="inline-block px-6 py-3 bg-[#0F766E] text-white text-sm font-semibold hover:bg-[#0D6B64] transition-colors">Back to Farmwatch</Link>
          </div>
        )}
        {state === "error" && (
          <div data-testid="unsubscribe-error">
            <XCircle size={48} className="text-[#DC2626] mx-auto mb-4" weight="fill" />
            <h1 className="font-serif text-3xl text-[#33302E] mb-3">Unsubscribe failed</h1>
            <p className="text-[#6B6661] mb-8">{message}</p>
            <Link to="/contact" className="inline-block px-6 py-3 border-2 border-[#0F766E] text-[#0F766E] text-sm font-semibold hover:bg-[#0F766E] hover:text-white transition-colors">Contact us</Link>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
